import React from 'react';
import { Create } from 'react-admin';

import RouteForm from '../RouteForm';

function RouteCreate(props) {
    return (
        <Create {...props}>
            <RouteForm />
        </Create>
    );
}

export default RouteCreate;
